/* eslint-disable */
/* eslint-disable no-alert, no-console */

// import Plyr from 'plyr';
import { initVideoObjectFit } from './videoObjectFit';

// Container Class
const PLAYER_CONTAINER_CLASS = 'js-player__container';

// holder Class
const PLAYER_HOLDER_CLASS = 'js-player__holder';

// Base Class, every player needs this class
const PLAYER_CLASS = 'js-player';
const PLAYER_CLASS_LIGHTBOX = 'js-player-lightbox';

// Extend Players by Class
const PLAYER_HERO_CLASS = 'js-player__container--hero';
const PLAYER_VIDEOELEMENT_CLASS = 'js-player__container--videoelement';
const PLAYER_GALLERYELEMENT_CLASS = 'js-player__container--galleryelement';
const PLAYER_DATA_CONFIG = 'data-jsplayer-config';

const baseConfig = {
    'autoplay': false,
    'clickToPlay': true,
    'touchToPlay': true,
    'muted': false,
    'volume': 1,
    'loop': { active: true },
    'controls': ['play'],
    'settings': [],
    'keyboard': { focused: false, global: false },
    'ratio': '16:9',
    'fullscreen': { enabled: true},
    'youtube': { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1},
    'vimeo' : { background: false, byline: false, portrait: false, title: false, speed: true, transparent: false }
  };

function hasClass(element, className) {
  if (!element) {
    return false;
  }

  return element.className.search(className) > -1;
}

// get the module asyncly
async function lazyLoadPlyr() {
  return await import(
    /* webpackChunkName: "plyrjs" */
    /* webpackMode: "eager" */
    'plyr'
  )
}

function initJsPlayers(opt = {}) {
    const globalOptions = Object.assign({}, { selector:document.querySelectorAll(`.${PLAYER_CONTAINER_CLASS}`) }, opt)
    const containers = globalOptions.selector
    const teaserPlayers = [];

    if (containers.length > 0) {
      lazyLoadPlyr().then((module) => {

        const Plyr = module.default;
        Array.from(containers).forEach((container) => {

            const holder = container.querySelector(`.${PLAYER_HOLDER_CLASS}`);
            const player = holder.querySelector(`.${PLAYER_CLASS}`);

            if (player) {
              initJsPlayer(Plyr, container, holder, player);
            }
        });

        document.addEventListener("lightboxopen", (e) => {
          const lightboxContainer = e.detail.container;
          if (lightboxContainer) {
            const playerHolder= lightboxContainer.querySelector(`.${PLAYER_HOLDER_CLASS}`);
            const playerLightbox = lightboxContainer.querySelector(`.${PLAYER_CLASS_LIGHTBOX}`);
            if (playerHolder && playerLightbox) {
              initJsPlayer(Plyr, lightboxContainer, playerHolder, playerLightbox);
            }
          }
        });
      });
    }
}

function initJsPlayer(Plyr, container, holder, player) {
  // initialize config
  const additionalConfig = JSON.parse(container.getAttribute(PLAYER_DATA_CONFIG));
  const config = Object.assign({}, baseConfig, {}, additionalConfig);
  // set youtube origin
  config.youtube.origin = window.location.origin;
  // initialize player
  const plyrObj = new Plyr(player, config);

  // use Parent of js-player__container for aspect ratio calculation instead of window
  const parentContainer = container.parentElement;

  plyrObj.on('ready', event => {
      initVideoObjectFit(holder, parentContainer);
      if (config.autoplay == true) {
          plyrObj.play();
      }
  });

  if (config.touchToPlay) {
    player.addEventListener('touchstart', (event) => {
        // Toggle Players
        plyrObj.togglePlay();
    });
  }
}


window.document.addEventListener('DOMContentLoaded', initJsPlayers);

export { initJsPlayers }
